import { createSelector } from '@reduxjs/toolkit';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { RootState } from '..';
import { isInteractiveEditActive } from './interactiveEditingSelectors';

export const isPanningDisabled = createSelector(
  (state: RootState) => state.editor.editInProgress,
  isInteractiveEditActive,
  (editInProgress, interactiveEditActive) => {
    // There can be no panning during interactive edits because mouse movement is controlling the edit in progress
    if (interactiveEditActive) return true;

    switch (editInProgress) {
      // If a nudge handler is being clicked-and-dragged, we disable panning since any clicking-and-dragging should be
      // used to move the nudge handler, not pan the camera.
      case 'EditingBearing':
      case 'EditingPlatePair':
      case 'EditingAnalogJoint':
      case 'EditingReferenceLineOffset':
      case 'EditingProfileJoint':
      case 'EditingWebJoint':
      case 'EditingSplice':
        return true;
      case 'EditingReferenceLineIntersection':
      case 'InsertingMember':
      case false:
        return false;
      default:
        assertExhaustiveSwitch(editInProgress);
    }
  },
);
